import React from 'react';
import PropTypes from 'prop-types';

import EdgeCrm from './edge_crm';
import LiteCrm from './lite_crm';
import PaginationButtons from 'components/pagination_buttons';

export default class MapInfoBubble extends React.Component {
  static propTypes = {
    edgeCrm: PropTypes.bool,
    elementRef: PropTypes.object,
    handleNavigationClick: PropTypes.func,
    navigationText: PropTypes.string,
    property: PropTypes.shape({
      id: PropTypes.number,
    }),
    propertyIds: PropTypes.array,
  };

  render() {
    const ContentComponent = this.props.edgeCrm ? EdgeCrm : LiteCrm;

    return (
      <div className="info-window" ref={this.props.elementRef}>
        <ContentComponent {...this.props} />
        {this.props.propertyIds && this.props.propertyIds.length > 1 && this.renderFooter()}
      </div>
    );
  }

  renderFooter() {
    const currentIndex = this.props.propertyIds.indexOf(this.props.property.id);
    return (
      <div className="info-window-footer w-100 d-inline-flex px-2 align-items-center">
        <PaginationButtons
          allIds={this.props.propertyIds}
          currentIndex={currentIndex}
          entityId={this.props.property.id}
          nextIndex={this.props.propertyIds.length < currentIndex + 1 ? null : currentIndex + 1}
          prevIndex={currentIndex - 1 < 0 ? null : currentIndex - 1}
          onClick={this.handleClick}
        />
        <div className="ps-4 p-2">
          {currentIndex + 1} of {this.props.propertyIds.length} {this.props.navigationText}
        </div>
      </div>
    );
  }

  handleClick = (e, index) => {
    this.props.handleNavigationClick(this.props.propertyIds[index]);
  }
}
